@if (item) {
  @if (item.events.allEvents.length > 0) {
    <div class="all-events">
      <h2>All events</h2>
      @for (event of item.events.allEvents | filterOutEvents; track index; let index = $index) {
        <div class="all-events__event">
          <div class="all-events__event--name">{{ event.name }}</div>
          @if (event.location) {
            <div class="all-events__event--location">{{ event.location.name }}</div>
          }
          @for (details of event.details; track index; let index = $index) {
            <div class="all-events__event--date">
              @if (details.timeLocal) {
                <div>
                  {{ details.timeLocal | date }}
                  @if (details.timeLocal | isNotMidnight) {
                    {{ ' ' }}{{ details.timeLocal | date: timeFormat }}
                  }
                </div>
              } @else {
                <div>
                  {{ details.timeUtc | date }}
                  @if (details.timeUtc | isNotMidnight) {
                    {{ ' ' }}{{ details.timeUtc | date: timeFormat }}
                  }
                </div>
              }
              @if (details.containerNo) {
                <div>({{ details.containerNo }})</div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
} @else {
  <app-all-events-skeleton></app-all-events-skeleton>
}
